<template>
  <div></div>
</template>

<script>
import sha1 from 'sha1'
export default {
  created() {
    this.ini()
  },
  methods: {
    ini() {
      // 创建实例
      const appId = '4eaf2e8a8b1045c5940a27cab1f6ee30'
      const Secret = '7s8wDUTHln2Vqw8a1iVeqbctbSi0CeF7'
      const timestamp = Math.floor(new Date().getTime()/ 1000)//.toString()
      const nonce = 'hyhr2025'
      const fileId = 'test'
      const officeType = 'xlsx'
      const mode = 'simple'
      const str = `app_id=${appId}&app_secret=${Secret}&nonce=${nonce}&timestamp=${timestamp}`
      const sign = sha1(str)//.toString().toUpperCase()
      // console.log(str,sign);
      const config = {
        appId: appId,
        signature: {
          sign: sign,
          nonce: nonce,
          timeStamp: timestamp
        },
        officeType: officeType,
        fileId: fileId,
        mode: mode
      }
      console.log(str,sign,config);
      const instance = TencentDocsSDK.init(config)    
    }
  }
}
</script>

<style></style>
